/**
 * Convert a MIME content type to a user-friendly format
 * @param {string} contentType - MIME type (e.g., "image/jpeg")
 * @returns {string} User-friendly type description (e.g., "JPEG Image")
 */
export function getSimpleContentType(contentType) {
  const parts = contentType.split('/');
  const mainType = parts[0];
  const subType = parts[1];
  
  // Map common MIME types to friendly names
  if (mainType === 'image') {
    return (subType === 'jpeg' || subType === 'jpg') ? 'JPEG Image' : 
           subType === 'png' ? 'PNG Image' :
           subType === 'gif' ? 'GIF Image' :
           subType === 'svg+xml' ? 'SVG Image' : 
           'Image';
  } else if (mainType === 'video') {
    return subType === 'mp4' ? 'MP4 Video' :
           subType === 'quicktime' ? 'MOV Video' :
           subType === 'webm' ? 'WebM Video' : 
           'Video';
  } else if (mainType === 'audio') {
    return subType === 'mp3' ? 'MP3 Audio' :
           subType === 'wav' ? 'WAV Audio' :
           subType === 'ogg' ? 'OGG Audio' : 
           'Audio';
  } else if (mainType === 'application') {
    return subType === 'pdf' ? 'PDF Document' :
           subType === 'msword' || subType.includes('wordprocessing') ? 'Word Document' :
           subType.includes('spreadsheet') ? 'Spreadsheet' :
           subType.includes('presentation') ? 'Presentation' :
           subType === 'zip' ? 'ZIP Archive' :
           subType === 'json' ? 'JSON File' :
           subType === 'javascript' ? 'JavaScript File' :
           'Document';
  } else if (mainType === 'text') {
    return subType === 'plain' ? 'Text File' :
           subType === 'html' ? 'HTML File' :
           subType === 'css' ? 'CSS File' :
           'Text';
  }
  
  // Default case
  return mainType.charAt(0).toUpperCase() + mainType.slice(1);
}

/**
 * Get an appropriate icon class for a file based on its content type
 * @param {string} contentType - MIME type (e.g., "image/jpeg")
 * @returns {string} Bootstrap icon class
 */
export function getFileIconClass(contentType) {
  const mainType = contentType.split('/')[0];
  const subType = contentType.split('/')[1];
  
  switch (mainType) {
    case 'image':
      return 'bi-file-image';
    case 'video':
      return 'bi-file-play';
    case 'audio':
      return 'bi-file-music';
    case 'text':
      return 'bi-file-text';
    case 'application':
      if (subType === 'pdf') return 'bi-file-pdf';
      if (subType.includes('wordprocessing')) return 'bi-file-word';
      if (subType.includes('spreadsheet')) return 'bi-file-excel';
      if (subType.includes('presentation')) return 'bi-file-ppt';
      if (subType === 'zip' || subType.includes('compressed')) return 'bi-file-zip';
      if (subType === 'json') return 'bi-file-code';
      return 'bi-file-earmark';
    default:
      return 'bi-file';
  }
} 